/*
 * @Date: 2023-12-04 18:24:51
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-12 18:52:17
 * @FilePath: \hisea-ssr\src\components\Gallery\CustomizeOptions\customizeOptions.js
 */
import { normalizeColorLabel } from '@/lib/color-url';
import { cn } from '@/lib/utils';
import { ColorItem, Maybe } from '@/types/graphql.prod';
import { BrowserPersistence } from '@/util';
import resourceUrl from '@/util/makeUrl';
import { Dispatch, SetStateAction } from 'react';
import EmblaCarousel from './EmblaCarousel';
import classes from './customizeOptions.module.css';
export const CustomizeOptions = ({
  colorOptions,
  allColorCount,
  selectedColor,
  setSelectedColor,
  setGalleryImagesPC,
  setGalleryImagesHoverPC,
  url_key,
}: {
  colorOptions: Maybe<ColorItem>[];
  allColorCount: number;
  selectedColor: Maybe<ColorItem>;
  setSelectedColor: Dispatch<SetStateAction<Maybe<ColorItem> | null>>;
  setGalleryImagesPC: Dispatch<SetStateAction<string>>;
  setGalleryImagesHoverPC: Dispatch<SetStateAction<string>>;
  url_key: string;
}) => {
  const handleClick = (value: ColorItem) => {
    setSelectedColor(value);

    const { image, hover_image } = value || {};

    setGalleryImagesPC(image ?? '');
    setGalleryImagesHoverPC(hover_image ?? '');
  };

  const storage = new BrowserPersistence();

  const storeCode = storage.getItem('store_view_code') || process.env.NEXT_PUBLIC_STORE_VIEW_CODE;

  const getLink = (colorValue: Maybe<ColorItem>) => {
    const basePath = storeCode === 'hisea_de' ? '/de' : '';
    const colorPath = colorValue ? `-${normalizeColorLabel(colorValue.label)}` : '';

    return resourceUrl(`${basePath}/${url_key}${colorPath}.html`);
  };
  const OPTIONS = {
    containScroll: true,
    align: 'start',
  };
  return (
    <div className={cn('w-full', classes.root)}>
      <EmblaCarousel
        slides={colorOptions}
        options={OPTIONS}
        url_key={url_key}
        selectedColor={selectedColor}
        handleClick={handleClick}
      />
      {/*<ul>
         {colorOptions.map((value, index) => {
          const rgb = value?.rgb ?? '';
          const blockStyle = /^#\S+$/.test(rgb)
            ? {
                backgroundColor: rgb,
              }
            : {
                backgroundImage: `url(${process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL}media/attribute/swatch/swatch_thumb/110x90${rgb})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              };
          const bgSrc = value?.image ?? '';
          const bgStyle = {
            backgroundImage: `url(${bgSrc})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          };
          const itemClass = selectedColor?.rgb === rgb ? classes.activeItem : classes.item;

          const productLink = getLink(value);

          return (
            <Link
              href={productLink}
              aria-hidden='true'
              className={itemClass}
              key={index}
              onClick={e => {
                e.preventDefault();

                if (value) {
                  handleClick(value);
                }
              }}
              style={bgStyle}
            />
          );
        })}
      </ul> */}
      {/* {!isNaN(allColorCount) && allColorCount !== 0 && (
        <span className={classes.colorCount}>{`+ ${allColorCount}`}</span>
      )} */}
    </div>
  );
};
